import React, { useState, Fragment, useEffect } from "react";
import { userService } from "../../_services/user.service";
import {
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import Loader from "react-loaders";
import colors from "../../_helpers/colors";
import exceptionHandler from "../../_helpers/exceptionHandler";
import { api, getPageText } from "../../_services/api.service";
import {
  formatMoney,
  PartnerAlternativeMetricRenderer,
} from "./Components/PartnerAlternativeMetricRenderer";
// import NotesSection from "../../Components/NotesSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import useFetcher from "../../_hooks/useFetcher.hook";
import { toast } from "react-toastify";

const PartnerAlternativeListModal = ({
  showModal,
  toggleModal,
  setScenarioId,
  scenarioId,
  props,
}) => {
  const currentUser = userService.getLoggedInUser();
  const [partnerAlternatives, setPartnerAlternatives] = useState([]);
  const [alternatives, setAlternatives] = useState([]);
  const [apiAlternatives, setApiAlternatives] = useState([]);
  const [isItemInfoVisible, setIsItemInfoVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [overlayAddRemoveButtonText, setAddRemoveButtonText] = useState(
    "Add and Close"
  );
  const [costLabel, setCostLabel] = useState("Cost");
  const [overlayMode, setOverlayMode] = useState("edit");

  const [isItemLoading, setIsItemLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingApiAlt, setIsLoadingApiAlt] = useState(false);
  const [searchString, setSearchString] = useState("");

  const [
    isAddNewAlternativeModalVisible,
    setIsAddNewAlternativeModalVisible,
  ] = useState(false);

  const [newItemTitle, setNewItemTitle] = useState("");
  const [newItemCost, setNewItemCost] = useState("");

  const [scenario, setScenario] = useState(null);
  const [partnerScenario, setPartnerScenario] = useState(null);
  const [partnerAlternativeList, setPartnerAlternativeList] = useState([]);
  const [metrics, setMetrics] = useState([]);

  //   let scenarioId = parseInt(props.match.params.scenarioId);

  const getTextAction = () => {
    return getPageText("alternatives", "top", currentUser.userId, scenarioId);
  };
  const { data: topText } = useFetcher(getTextAction, "");

  useEffect(() => {
    return () => {
      setScenarioId(0);
    };
  }, []);

  useEffect(() => {
    if (showModal && scenarioId > 0) {
      loadData();
    }
  }, [showModal, scenarioId]);

  const loadData = () => {
    setIsLoading(true);

    api.getScenarioById(scenarioId).then((data) => {
      setScenario(data);
      if (data.partnerScenarioID > 0) {
        api.getPartnerScenarioById(data.partnerScenarioID).then((ps) => {
          setPartnerScenario(ps);
          if (ps.useAltAPI) {
            loadMetrics(ps.partnerScenarioID);
          }
          if (ps && ps.lockAlternatives) {
            props.history.push({
              pathname: `/alternativesimportance/${scenarioId}`,
            });
          }
          if (ps && ps.costName !== "") {
            setCostLabel("Cost (" + ps.costName + ")");
          }
        });
      }

      api.getPartnerAlternativesByScenario(scenarioId).then(
        (items) => {
          // if (items == undefined || items == null || items.length == 0) {
          //   // props.history.push({
          //   //   pathname: `/alternatives/${scenarioId}`,
          //   // });
          //   setIsLoading(false);
          // } else {
          setPartnerAlternativeList(items);
          loadAlternatives([...items]);
          // }
        },
        (error) => {
          setIsLoading(false);
          exceptionHandler.handleError(error);
        }
      );
    });
  };

  const loadAlternatives = (partnerAlts) => {
    api.getAlternativesByScenario(scenarioId).then(
      (alts) => {
        let addedPartnerAlts = alts.filter((x) => x.partnerAlternativeID !== 0);
        if (addedPartnerAlts.length > 0) {
          addedPartnerAlts.forEach((element) => {
            let pa = partnerAlts.find(
              (x) => x.partnerAlternativeID == element.partnerAlternativeID
            );
            if (pa !== undefined) {
              partnerAlts.splice(partnerAlts.indexOf(pa), 1);
            }
          });
        }

        setPartnerAlternatives(partnerAlts);
        setAlternatives(alts);

        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        exceptionHandler.handleError(error);
      }
    );
  };

  const loadMetrics = (partnerScenarioID) => {
    api.getPartnerMetricsByPartnerScenario(partnerScenarioID).then((data) => {
      setMetrics(data);
    });
  };

  const onAddItemPressed = (item) => {
    let lst = [...partnerAlternatives];
    let alt = lst.find(
      (x) => x.partnerAlternativeID == item.partnerAlternativeID
    );
    api.createAlternative(currentUser.userId, scenarioId, alt).then(
      (data) => {
        loadData();
      },
      (error) => {
        exceptionHandler.handleError(error);
      }
    );
  };

  const onAddApiItemPressed = (item) => {
    let exists = alternatives.find((a) => {
      return a.alternativeName === item.alternativeName;
    });
    if (exists) {
      toast("Alternative already added!", {
        autoClose: 3000,
        type: toast.TYPE.WARNING,
        hideProgressBar: false,
      });
      return;
    }

    api.createAlternative(currentUser.userId, scenarioId, item).then(
      (data) => {
        loadData();
      },
      (error) => {
        exceptionHandler.handleError(error);
      }
    );
  };

  const onRemoveItem = (item) => {
    api.deleteAlternative(currentUser.userId, item.alternativeID).then(
      (data) => {
        loadData();
      },
      (error) => {
        exceptionHandler.handleError(error);
      }
    );
  };

  const toggleOverlay = () => {
    setIsItemInfoVisible(!isItemInfoVisible);
  };

  const updateAlternative = () => {
    setIsItemLoading(true);
    api
      .updateAlternative(currentUser.userId, { ...selectedItem })
      .then((data) => {
        loadAlternatives(partnerAlternativeList);
        setIsItemLoading(false);
        toggleOverlay();
      })
      .catch((e) => {
        setIsItemLoading(false);
        toggleOverlay();
      });
  };

  const onEditPressed = (alternativeId) => {
    setOverlayMode("edit");
    toggleOverlay();
    if (selectedItem && selectedItem.alternativeID === alternativeId) return;

    setSelectedItem(null);
    const alt = alternatives.find((x) => x.alternativeID == alternativeId);
    if (partnerScenario && partnerScenario.useIncludedAlternatives) {
      setIsItemLoading(true);
      api
        .getPartnerAlternativeByById(alt.partnerAlternativeID)
        .then((partnerAlt) => {
          if (partnerAlt) {
            setSelectedItem({
              ...alt,
              partnerAlternativeName: partnerAlt.partnerAlternativeName,
              partnerAlternativeMetrics: partnerAlt.partnerAlternativeMetrics,
            });
          } else {
            setSelectedItem(alt);
          }
          setIsItemLoading(false);
        })
        .catch((err) => {
          setIsItemLoading(false);
        });
    } else if (partnerScenario && partnerScenario.useAltAPI) {
      setIsItemLoading(true);
      api
        .getAPIAlternativeMetrics(alternativeId)
        .then((data) => {
          if (data) {
            let metrics = JSON.parse(data);
            setSelectedItem({
              ...alt,
              alternativeName: alt.alternativeName,
              alternativeAPIMetrics: metrics,
            });
          } else {
            setSelectedItem(alt);
          }
          setIsItemLoading(false);
        })
        .catch((err) => {
          setIsItemLoading(false);
        });
    } else {
      setSelectedItem(alt);
    }
  };

  const onInfoPressed = (item) => {
    setOverlayMode("view");
    setIsItemLoading(true);
    toggleOverlay();
    api
      .getPartnerAlternativeByById(item.partnerAlternativeID)
      .then((data) => {
        let prevAlt = partnerAlternatives.find(
          (x) => x.partnerAlternativeID == item.partnerAlternativeID
        );
        data.isSelected = prevAlt.isSelected;
        setSelectedItem(data);
        setAddRemoveButtonText(
          data.isSelected ? "Remove and Close" : "Add and Close"
        );
        setIsItemLoading(false);
      })
      .catch((err) => {
        setIsItemLoading(false);
      });
  };

  const onAddAlternativePressed = () => {
    if (newItemTitle !== "") {
      let alt = {
        alternativeID: -1,
        alternativeName: newItemTitle,
        partnerAlternativeName: newItemTitle,
        description: "",
        cost: newItemCost,
        partnerAlternativeID: 0,
      };
      api.createAlternative(currentUser.userId, scenarioId, alt).then(
        (data) => {
          loadAlternatives(partnerAlternativeList);
          setNewItemTitle("");
          setNewItemCost("");
          toggleAddNewAlternativeModal();
        },
        (err) => {
          setNewItemTitle("");
          setNewItemCost("");
          toggleAddNewAlternativeModal();
        }
      );
    }
  };

  const goToAlternativesImportance = () => {
    props.history.push({
      pathname: `/alternativesimportance/${scenarioId}`,
    });
  };

  const toggleAddNewAlternativeModal = () => {
    setIsAddNewAlternativeModalVisible(!isAddNewAlternativeModalVisible);
  };

  const showRemoveButton = (c) =>
    partnerAlternativeList.length == 0 ||
    c.partnerAlternativeID == 0 ||
    partnerAlternativeList.find(
      (x) => x.partnerAlternativeID == c.partnerAlternativeID
    ) == undefined ||
    !partnerAlternativeList.find(
      (x) => x.partnerAlternativeID == c.partnerAlternativeID
    ).mustHave;

  // find the parent node that contains the key name
  const findParent = (object, key) => {
    var parent;
    if (Array.isArray(object)) {
      parent = findParent(object[0], key);
    } else if (typeof object == "object") {
      parent = Object.keys(object).find(function(k) {
        if (k === key) {
          return true;
        }

        if (object[k] && typeof object[k] === "object") {
          let o = findParent(object[k], key);
          return o !== undefined;
        }

        return false;
      });
    }

    return parent;
  };

  const findVal = (object, key) => {
    var value;
    Object.keys(object).some(function(k) {
      if (k === key) {
        value = object[k];
        return true;
      }
      if (object[k] && typeof object[k] === "object") {
        value = findVal(object[k], key);
        return value !== undefined;
      }
      return false;
    });
    return value;
  };

  const searchAltAPI = async () => {
    try {
      let tpl = partnerScenario.altAPISearchTemplate;
      const key = partnerScenario.altAPIKey;
      let url = tpl.replace("[KEY]", key);
      const shouldFilter = url.indexOf("[SEARCHSTRING]") === -1;
      url = url.replace("[SEARCHSTRING]", searchString);
      setIsLoadingApiAlt(true);
      let reqOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };

      if (partnerScenario.altAPIKeyType === "auth header") {
        reqOptions.headers[partnerScenario.altAPIKeyName] = key;
      }

      var response = await fetch(url, reqOptions);
      var body = await response.json();

      let nodeName = findParent(body, partnerScenario.altAPINameField);
      let nodeValue = findVal(body, nodeName);
      let alts = parseApiAlternatives(nodeValue);
      if (shouldFilter && alts && alts.length > 0 && searchString.length > 0) {
        const ss = searchString.toLowerCase();
        alts = alts.filter(
          (a) =>
            a.alternativeName.toLowerCase().includes(ss) ||
            a.description.toLowerCase().includes(ss)
        );
      }
      setApiAlternatives(alts);
    } catch (err) {
      const cb = () => {
        toast("Oops! An error has occured.", {
          autoClose: 3000,
          type: toast.TYPE.ERROR,
          hideProgressBar: false,
        });
      };
      exceptionHandler.handleError(err, cb);
    } finally {
      setIsLoadingApiAlt(false);
    }
  };

  const parseApiAlternatives = (data) => {
    if (!data || data.length === 0) return [];

    let alts = [];
    let i = 0;
    data.forEach((a) => {
      let altMetrics = metrics.map((m) => {
        let metricValue;
        if (
          typeof m["altAPITemplate"] === "string" &&
          m["altAPITemplate"].length > 0
        ) {
          let nodeValue = a[m["altAPIFieldName"]];
          let template = m["altAPITemplate"];
          metricValue = template.replace("[APIDATA]", nodeValue);
        } else {
          metricValue = a[m["altAPIFieldName"]];
        }

        let updates = { partnerAlternativeMetricValue: metricValue };
        if (m.partnerMetricType === "Address (Map)") {
          let latitudeNode = m["altAPILatitudeField"];
          let longitudeNode = m["altAPILongitudeField"];

          if (!latitudeNode && a["lat"] !== undefined) latitudeNode = "lat";
          if (!latitudeNode && a["latitude"] !== undefined)
            latitudeNode = "latitude";
          if (!longitudeNode && a["lon"] !== undefined) longitudeNode = "lon";
          if (!longitudeNode && a["longitude"] !== undefined)
            longitudeNode = "longitude";

          let metricExtraValue;
          if (latitudeNode) {
            metricExtraValue = a[latitudeNode] + ",";
            if (longitudeNode) metricExtraValue += a[longitudeNode];
          }
          if (metricExtraValue !== undefined)
            updates["partnerAlternativeMetricExtraValue"] = metricExtraValue;
        }

        return { ...m, ...updates };
      });
      alts.push({
        alternativeName: a[partnerScenario.altAPINameField],
        cost: a[partnerScenario.altAPICostField],
        description: a[partnerScenario.altAPIDescriptionField],
        altId: i++,
        alternativeAPIMetrics: altMetrics,
      });
    });

    return alts;
  };

  const renderAlternatives = (alts) => {
    return alts.map((c) => {
      return (
        <Row
          key={c.partnerAlternativeID.toString()}
          style={{
            padding: "10px",
            borderBottom: "1px solid lightgray",
          }}
        >
          <Col md="8">
            <FontAwesomeIcon
              style={{ cursor: "pointer", fontSize: "20px" }}
              icon={faInfoCircle}
              onClick={() => onInfoPressed(c)}
            />
            <p
              style={{
                margin: 0,
                fontWeight: "bold",
                color: colors.PRIMARY_TEXT_COLOR,
                display: "inline-block",
                marginLeft: "10px",
              }}
            >
              {c.partnerAlternativeName}
            </p>
          </Col>
          {scenario != null && scenario.useCost && (
            <Col md="2">
              <p
                style={{
                  margin: 0,
                  color: colors.PRIMARY_TEXT_COLOR,
                }}
                className="pull-right"
              >
                {formatMoney(c.cost)}
              </p>
            </Col>
          )}
          <Col md="2">
            {showRemoveButton(c) && (
              <i
                className="fa fa-plus-circle"
                style={{
                  color: colors.DODGER_BLUE,
                  fontSize: "20px",
                  cursor: "pointer",
                  float: "right",
                }}
                onClick={() => onAddItemPressed(c)}
              />
            )}
          </Col>
        </Row>
      );
    });
  };

  const renderApiAlternatives = (alts) => {
    return alts.map((c) => {
      return (
        <Row
          key={c.altId}
          style={{
            padding: "10px",
            borderBottom: "1px solid lightgray",
          }}
        >
          <Col md="8">
            <FontAwesomeIcon
              style={{ cursor: "pointer", fontSize: "20px" }}
              icon={faInfoCircle}
              onClick={() => onAltApiInfoPressed(c)}
            />
            <p
              style={{
                margin: 0,
                fontWeight: "bold",
                color: colors.PRIMARY_TEXT_COLOR,
                display: "inline-block",
                marginLeft: "10px",
              }}
            >
              {c.alternativeName}
            </p>
          </Col>
          <Col md="2">
            <p
              style={{
                margin: 0,
                color: colors.PRIMARY_TEXT_COLOR,
              }}
              className="pull-right"
            >
              {c.cost && formatMoney(c.cost)}
            </p>
          </Col>
          <Col md="2">
            {showRemoveButton(c) && (
              <i
                className="fa fa-plus-circle"
                style={{
                  color: colors.DODGER_BLUE,
                  fontSize: "20px",
                  cursor: "pointer",
                  float: "right",
                }}
                onClick={() => onAddApiItemPressed(c)}
              />
            )}
          </Col>
        </Row>
      );
    });
  };

  const onAltApiInfoPressed = (item) => {
    setOverlayMode("view");
    toggleOverlay();
    setSelectedItem(item);
    setAddRemoveButtonText(
      item.isSelected ? "Remove and Close" : "Add and Close"
    );
  };

  const handleEnter = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) searchAltAPI();
  };

  const addAlternativeButtonName = `+ Add ${
    !partnerScenario || partnerScenario.ahpOnly === false
      ? "alternative"
      : partnerScenario.alternativeName.toLowerCase()
  }`;

  return (
    <Fragment>
      <Modal
        size="lg"
        isOpen={showModal}
        toggle={() => toggleModal()}
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>
          {`What ${
            !partnerScenario
              ? "alternatives"
              : partnerScenario.alternativeNamePlural.toLowerCase()
          } do you want to review?`}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md="12">
              {/* <div style={{ display: "flex", alignItems: "center" }}>
           
            <h3
              style={{
                marginBottom: "0px",
                color: colors.DODGER_BLUE,
                fontWeight: "bold",
              }}
            >
              {`What ${
                !partnerScenario
                  ? "alternatives"
                  : partnerScenario.alternativeNamePlural.toLowerCase()
              } do you want to review?`}
            </h3>
          </div> */}

              {topText !== "" && <p className="normal-info-text">{topText}</p>}
              <div className="custom-card">
                <h5 style={{ padding: "5px" }}>
                  Your{" "}
                  {!partnerScenario
                    ? "alternatives"
                    : partnerScenario.alternativeNamePlural.toLowerCase()}
                </h5>
                {isLoading && <Loader style={{}} type="ball-pulse" active />}
                {!isLoading &&
                  alternatives.length > 0 &&
                  alternatives.map((c) => {
                    return (
                      <Row
                        key={c.alternativeID.toString()}
                        style={{
                          padding: "10px",
                          borderBottom: "1px solid lightgray",
                        }}
                      >
                        <Col md="8">
                          <FontAwesomeIcon
                            style={{ cursor: "pointer", fontSize: "20px" }}
                            icon={faEdit}
                            onClick={() => onEditPressed(c.alternativeID)}
                          />
                          <p
                            style={{
                              margin: 0,
                              fontWeight: "bold",
                              color: colors.PRIMARY_TEXT_COLOR,
                              display: "inline-block",
                              marginLeft: "10px",
                            }}
                          >
                            {c.alternativeName}
                          </p>
                        </Col>
                        {scenario != null && scenario.useCost && (
                          <Col md="2">
                            <p
                              style={{
                                margin: 0,
                                color: colors.PRIMARY_TEXT_COLOR,
                              }}
                              className="pull-right"
                            >
                              {formatMoney(c.cost)}
                            </p>
                          </Col>
                        )}
                        <Col md="2">
                          {showRemoveButton(c) && (
                            <i
                              className="fa fa-times-circle"
                              style={{
                                color: colors.PRIMARY_TEXT_COLOR,
                                fontSize: "20px",
                                cursor: "pointer",
                                float: "right",
                              }}
                              onClick={() => onRemoveItem(c)}
                            />
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                <Row style={{ marginTop: "20px" }}>
                  <Col md="12">
                    <Button
                      color="primary"
                      style={{ display: "inline-block" }}
                      onClick={() => {
                        toggleAddNewAlternativeModal();
                      }}
                    >
                      {addAlternativeButtonName}
                    </Button>
                  </Col>
                </Row>
              </div>

              {partnerScenario && partnerScenario.useAltAPI && (
                <div className="custom-card" style={{ marginTop: 30 }}>
                  <h5 style={{ padding: "5px", color: colors.DODGER_BLUE }}>
                    Select the{" "}
                    {partnerScenario.alternativeNamePlural.toLowerCase()} you
                    want to evaluate
                  </h5>
                  <Row>
                    <Col md="4" style={{ marginBottom: "10px" }}>
                      <input
                        type="search"
                        placeholder="Search..."
                        className="form-control input-sm leguard-search-input"
                        onChange={(e) => setSearchString(e.target.value)}
                        onKeyUp={handleEnter}
                      />
                    </Col>
                    <Col md="2">
                      <Button color="primary" onClick={searchAltAPI}>
                        Search
                      </Button>
                    </Col>
                  </Row>
                  {isLoadingApiAlt && (
                    <Loader style={{}} type="ball-pulse" active />
                  )}
                  {!isLoadingApiAlt && renderApiAlternatives(apiAlternatives)}
                </div>
              )}

              {partnerScenario &&
                partnerScenario.useIncludedAlternatives &&
                partnerAlternatives.length > 0 && (
                  <div className="custom-card">
                    <h5 style={{ padding: "5px", color: colors.DODGER_BLUE }}>
                      Select the{" "}
                      {partnerScenario.alternativeNamePlural.toLowerCase()} you
                      want to evaluate
                    </h5>
                    {isLoading && (
                      <Loader style={{}} type="ball-pulse" active />
                    )}
                    {!isLoading && renderAlternatives(partnerAlternatives)}
                  </div>
                )}
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col md="12">
              <Button
                color="primary"
                onClick={toggleModal}
                style={{ display: "inline-block" }}
              >
                Close
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal
        size="md"
        isOpen={isItemInfoVisible}
        toggle={() => toggleOverlay()}
        backdrop="static"
      >
        <Fragment>
          <ModalHeader toggle={() => toggleOverlay()}>
            {overlayMode === "view" && <div>Information</div>}
            {overlayMode === "edit" && <div>Edit Alternative</div>}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md="12">
                {isItemLoading && (
                  <Loader style={{}} type="ball-pulse" active />
                )}
                {!isItemLoading && selectedItem !== null && (
                  <div>
                    {overlayMode == "edit" &&
                      scenario !== null &&
                      scenario.userID == currentUser.userId && (
                        <div>
                          <div className="form-group">
                            <label>Name</label>
                            <Input
                              type="text"
                              value={selectedItem.alternativeName}
                              onChange={(e) => {
                                let obj = {
                                  ...selectedItem,
                                  alternativeName: e.target.value,
                                };
                                setSelectedItem(obj);
                              }}
                            />
                          </div>

                          {scenario != null && scenario.useCost && (
                            <div className="form-group">
                              <label>{costLabel}</label>
                              <Input
                                type="number"
                                value={selectedItem.cost.toString()}
                                onChange={(e) => {
                                  let obj = {
                                    ...selectedItem,
                                    cost: e.target.value,
                                  };
                                  setSelectedItem(obj);
                                }}
                              />
                            </div>
                          )}
                          <div className="form-group">
                            <label>Description</label>
                            <Input
                              type="textarea"
                              value={selectedItem.description}
                              onChange={(e) => {
                                let obj = {
                                  ...selectedItem,
                                  description: e.target.value,
                                };
                                setSelectedItem(obj);
                              }}
                            />
                          </div>
                        </div>
                      )}

                    {selectedItem.partnerAlternativeName &&
                      selectedItem.partnerAlternativeMetrics && (
                        <div>
                          <h3>{selectedItem.partnerAlternativeName}</h3>
                          {selectedItem.partnerAlternativeMetrics !== null &&
                            selectedItem.partnerAlternativeMetrics.map(
                              (pam, idx) => {
                                return PartnerAlternativeMetricRenderer(
                                  pam,
                                  idx
                                );
                              }
                            )}
                          <p>
                            <span style={{ fontWeight: "bold" }}>
                              Description:
                            </span>{" "}
                            {selectedItem.description}
                          </p>
                        </div>
                      )}

                    {selectedItem &&
                      selectedItem.alternativeName &&
                      selectedItem.alternativeAPIMetrics && (
                        <div>
                          <h3>{selectedItem.alternativeName}</h3>
                          {selectedItem.alternativeAPIMetrics.map(
                            (pam, idx) => {
                              return PartnerAlternativeMetricRenderer(pam, idx);
                            }
                          )}
                          <p>
                            <span style={{ fontWeight: "bold" }}>
                              Description:
                            </span>{" "}
                            {selectedItem.description}
                          </p>
                        </div>
                      )}

                    {/* {overlayMode === "edit" && selectedItem !== null && (
                      <NotesSection
                        nodeType={"Alternative"}
                        nodeId={selectedItem.alternativeID}
                      />
                    )} */}
                  </div>
                )}
              </Col>
            </Row>

            <Button
              color="primary"
              style={{ display: "inline-block", marginRight: "10px" }}
              onClick={toggleOverlay}
            >
              Close
            </Button>
            {overlayMode === "edit" && (
              <Button
                style={{ display: "inline-block" }}
                color="primary"
                onClick={updateAlternative}
              >
                Save
              </Button>
            )}
          </ModalBody>
        </Fragment>
      </Modal>

      <Modal
        size="md"
        isOpen={isAddNewAlternativeModalVisible}
        toggle={() => toggleAddNewAlternativeModal()}
        backdrop="static"
      >
        <Fragment>
          <ModalHeader toggle={() => toggleAddNewAlternativeModal()} />
          <ModalBody>
            <Row>
              <Col md="12">
                <h3>
                  Add new{" "}
                  {!partnerScenario
                    ? "alternative"
                    : partnerScenario.alternativeName.toLowerCase()}
                </h3>

                <div className="form-group">
                  <label>Name</label>
                  <Input
                    type="text"
                    value={newItemTitle}
                    onChange={(e) => setNewItemTitle(e.target.value)}
                  />
                </div>

                {scenario != null && scenario.useCost && (
                  <div className="form-group">
                    <label>{costLabel}</label>
                    <Input
                      type="number"
                      value={newItemCost}
                      onChange={(e) => {
                        setNewItemCost(e.target.value);
                      }}
                    />
                  </div>
                )}
              </Col>
            </Row>

            <Button
              color="primary"
              style={{ display: "inline-block" }}
              onClick={toggleAddNewAlternativeModal}
            >
              Close
            </Button>
            {scenario !== null && scenario.userID == currentUser.userId && (
              <Button
                style={{ display: "inline-block", marginLeft: 10 }}
                color="primary"
                onClick={onAddAlternativePressed}
              >
                Save
              </Button>
            )}
          </ModalBody>
        </Fragment>
      </Modal>
    </Fragment>
  );
};

export default PartnerAlternativeListModal;
